import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { authActions } from '../../../../shared/store/redux/auth-slice';
import { postJson } from '../../../../shared/utils/utils';
import { getMainClassesIds } from '../../../../shared/utils/userDetailsUtils';
import { sendActionEvent } from '../../../../shared/utils/analytics/ga4';
import GoogleMeetBtn from '../googleMeetBtn/GoogleMeetBtn';
import classes from './GoogleMeetSection.module.css';

const GoogleMeetSection = () => {

    const { userDetails } = useSelector(state => state.auth);
    const { texts } = useSelector(state => state.translate);
    const [allMainClasses, setAllMainClasses] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        const allMainClasses = getMainClassesIds(userDetails);
        setAllMainClasses(allMainClasses);
    }, [userDetails]);


    const toggleMeetStatus = async (studyGroupId, newStatus) => {
        sendActionEvent("googlemeet", newStatus ? "disable" : "enable");
        const res = await postJson(`${window.config.baseApiUrl}/api/cloudenv/editMeet`, {
            studyGroupId,
            disableMeetUrl: newStatus
        });
        if (res.ok) {
            if (userDetails) {
                const updatedUsermainClasses = {
                    ...userDetails.defaultSchool,
                    mainClasses: userDetails.defaultSchool?.mainClasses?.map(mc =>
                        mc.id === studyGroupId ? { ...mc, disableMeetUrl: newStatus } : mc
                    )
                };
                dispatch(authActions.setDefaultSchool(updatedUsermainClasses));
            }
        }
        else {
            alert(texts?.error);
        }
    };
    return (
        <div className={classes.GoogleMeetSection}>
            <div className={classes.GoogleMeetInfo}>
                <div className={classes.GoogleMeetInfoTitle}>{texts.googleMeet}</div>
                {allMainClasses?.length > 0 ?
                    <div className={classes.GoogleMeetInfoDescription}>
                        {texts.googleMeetDescription}
                    </div>
                    :
                    <div className={classes.GoogleMeetInfoDescriptionNoMainClasses}>
                        {texts.googleMeetDescriptionNoMainClasses}
                    </div>
                }
            </div>
            <div className={classes.GoogleMeetBtns}>
                {allMainClasses?.map(mainClass =>
                    <>
                        <GoogleMeetBtn key={mainClass.id} studyGroup={mainClass} copyBtn={true} />
                        <div className={classes.CancelMainMeet}>
                            <input type="checkbox" checked={!mainClass.disableMeetUrl} className={classes.ToggleBtn} onChange={() => toggleMeetStatus(mainClass.id, !mainClass.disableMeetUrl)} />
                            <span>{mainClass.disableMeetUrl ? texts.disableMeetUrl : texts.enableMainMeet}</span>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default GoogleMeetSection;